import gql from 'graphql-tag';

export const GUEST_UPGRADEABLE_TO_MEMBER_QUERY = gql`
  query GuestUpgradeableToMember(
    $token: String!
    $billingAddress: AddressInput!
    $card: CardInput!
    $country: CountryCodes!
    $email: String!
    $firstName: String!
    $lastName: String!
  ) {
    isGuestUpgradeableToMember(
      token: $token
      billingAddress: $billingAddress
      card: $card
      country: $country
      email: $email
      firstName: $firstName
      lastName: $lastName
    )
  }
`;
